var map = {
	"./components/auth/CompanyLoginComponent.vue": 1215,
	"./components/auth/LoginComponent.vue": 3159,
	"./components/auth/MagicLoginComponent.vue": 4670,
	"./components/auth/TwoFactorAuthenticationComponent.vue": 6560,
	"./components/auth/passwords/EmailResetComponent.vue": 6003,
	"./components/auth/passwords/ForgotComponent.vue": 8638,
	"./components/auth/passwords/PhoneResetComponent.vue": 3805,
	"./components/auth/passwords/ResetComponent.vue": 5122,
	"./components/auth/passwords/VerifyComponent.vue": 9125,
	"./components/dashboard/AccountComponent.vue": 8337,
	"./components/dashboard/DashboardComponent.vue": 7792,
	"./components/dashboard/ProfileComponent.vue": 4259,
	"./components/dashboard/SettingsComponent.vue": 4731,
	"./components/dashboard/back-office/CompaniesComponent.vue": 6217,
	"./components/dashboard/back-office/DashboardComponent.vue": 7992,
	"./components/dashboard/back-office/DocumentsComponent.vue": 8022,
	"./components/dashboard/back-office/FeesComponent.vue": 2627,
	"./components/dashboard/back-office/FxRatesComponent.vue": 1947,
	"./components/dashboard/back-office/MessagesComponent.vue": 8858,
	"./components/dashboard/back-office/PortfoliosComponent.vue": 882,
	"./components/dashboard/back-office/ProfileComponent.vue": 469,
	"./components/dashboard/back-office/RequestsComponent.vue": 1929,
	"./components/dashboard/back-office/TransactionsComponent.vue": 9826,
	"./components/dashboard/back-office/companies/AttachCompanyUserComponent.vue": 142,
	"./components/dashboard/back-office/companies/ManageCompaniesComponent.vue": 3997,
	"./components/dashboard/back-office/companies/NewCompanyComponent.vue": 5270,
	"./components/dashboard/back-office/companies/UploadCompaniesComponent.vue": 2342,
	"./components/dashboard/back-office/companies/ViewCompanyComponent.vue": 8124,
	"./components/dashboard/back-office/companies/partials/BankAccountInformation.vue": 2740,
	"./components/dashboard/back-office/companies/partials/CompanyExecutiveInformationComponent.vue": 1963,
	"./components/dashboard/back-office/companies/partials/CompanyInformationComponent.vue": 4679,
	"./components/dashboard/back-office/companies/partials/CompanyUsersComponent.vue": 8492,
	"./components/dashboard/back-office/companies/partials/DetachUserModal.vue": 4010,
	"./components/dashboard/back-office/companies/partials/EditCompanyUserModal.vue": 9155,
	"./components/dashboard/back-office/companies/partials/FinancialInformation.vue": 4577,
	"./components/dashboard/back-office/companies/partials/IdentificationInformation.vue": 525,
	"./components/dashboard/back-office/companies/partials/PersonalInformation.vue": 5454,
	"./components/dashboard/back-office/companies/partials/PortfolioInformation.vue": 1899,
	"./components/dashboard/back-office/companies/partials/RiskProfileInformation.vue": 9082,
	"./components/dashboard/back-office/companies/partials/ViewAttachedInstitutionUserModalComponent.vue": 6687,
	"./components/dashboard/back-office/fees/ManageFeesComponent.vue": 8188,
	"./components/dashboard/back-office/fees/NewFeeComponent.vue": 3643,
	"./components/dashboard/back-office/fees/UploadFeesComponent.vue": 5240,
	"./components/dashboard/back-office/fees/ViewFeeComponent.vue": 4796,
	"./components/dashboard/back-office/messages/Inbox.vue": 4427,
	"./components/dashboard/back-office/messages/InboxComponent.vue": 9631,
	"./components/dashboard/back-office/messages/ViewMessage.vue": 8158,
	"./components/dashboard/back-office/messages/ViewMessageComponent.vue": 8607,
	"./components/dashboard/back-office/messages/partials/InboxList.vue": 4111,
	"./components/dashboard/back-office/messages/partials/InboxListMessage.vue": 9967,
	"./components/dashboard/back-office/policies/ManagePoliciesComponent.vue": 174,
	"./components/dashboard/back-office/policies/NewPolicyComponent.vue": 5496,
	"./components/dashboard/back-office/policies/ViewPolicyComponent.vue": 6622,
	"./components/dashboard/back-office/portfolios/CreatePortfolioComponent.vue": 2632,
	"./components/dashboard/back-office/portfolios/ManagePortfoliosComponent.vue": 4970,
	"./components/dashboard/back-office/portfolios/NewPortfolioComponent.vue": 3311,
	"./components/dashboard/back-office/portfolios/ViewPortfolioComponent.vue": 9441,
	"./components/dashboard/back-office/requests/ManageRequests.vue": 8351,
	"./components/dashboard/back-office/requests/ManageRequestsComponent.vue": 6082,
	"./components/dashboard/back-office/requests/ViewRequest.vue": 3982,
	"./components/dashboard/back-office/requests/ViewRequestComponent.vue": 3557,
	"./components/dashboard/back-office/transactions/ManageTransactions.vue": 9681,
	"./components/dashboard/back-office/transactions/ManageTransactionsComponent.vue": 905,
	"./components/dashboard/back-office/transactions/NewTransaction.vue": 9853,
	"./components/dashboard/back-office/transactions/NewTransactionComponent.vue": 9539,
	"./components/dashboard/back-office/transactions/UploadTransactions.vue": 3710,
	"./components/dashboard/back-office/transactions/UploadTransactionsComponent.vue": 7032,
	"./components/dashboard/back-office/transactions/ViewTransaction.vue": 9855,
	"./components/dashboard/back-office/transactions/ViewTransactionComponent.vue": 3737,
	"./components/dashboard/back-office/transactions/partials/RequestInformation.vue": 4234,
	"./components/dashboard/back-office/transactions/partials/TransactionInformation.vue": 2331,
	"./components/dashboard/client/ApprovalsComponent.vue": 4392,
	"./components/dashboard/client/DashboardComponent.vue": 9639,
	"./components/dashboard/client/DocumentsComponent.vue": 387,
	"./components/dashboard/client/MessagesComponent.vue": 9579,
	"./components/dashboard/client/PortfolioComponent.vue": 5342,
	"./components/dashboard/client/RequestsComponent.vue": 3405,
	"./components/dashboard/client/SetGoalComponent.vue": 9929,
	"./components/dashboard/client/TradeComponent.vue": 9594,
	"./components/dashboard/client/approvals/ManageApprovalsComponent.vue": 3013,
	"./components/dashboard/client/approvals/ViewApprovalComponent.vue": 3066,
	"./components/dashboard/client/approvals/partials/ApprovalList.vue": 7625,
	"./components/dashboard/client/approvals/partials/ApprovalListPagination.vue": 3445,
	"./components/dashboard/client/approvals/partials/requests/CreditBankApproval.vue": 327,
	"./components/dashboard/client/approvals/partials/requests/RequestApproval.vue": 5567,
	"./components/dashboard/client/approvals/partials/requests/SettingsApproval.vue": 8423,
	"./components/dashboard/client/messages/InboxComponent.vue": 9589,
	"./components/dashboard/client/messages/NewMessageComponent.vue": 8464,
	"./components/dashboard/client/messages/SentComponent.vue": 6925,
	"./components/dashboard/client/messages/ViewMessageComponent.vue": 4515,
	"./components/dashboard/client/messages/partials/ClientInboxList.vue": 8563,
	"./components/dashboard/client/partials/AllocationTableComponent.vue": 3894,
	"./components/dashboard/client/partials/ApprovalAlertComponent.vue": 4869,
	"./components/dashboard/client/partials/DocumentsTableComponent.vue": 7693,
	"./components/dashboard/client/partials/TransactionsTableComponent.vue": 1248,
	"./components/dashboard/client/partials/charts/AllocationChartComponent.vue": 3527,
	"./components/dashboard/client/partials/charts/OverallChartComponent.vue": 7047,
	"./components/dashboard/client/partials/charts/partials/OverallChartMobile.vue": 8929,
	"./components/dashboard/client/partials/nav/ClientAccountProfileNavComponent.vue": 3688,
	"./components/dashboard/client/partials/nav/ClientCompanyProfileNavComponent.vue": 2086,
	"./components/dashboard/client/partials/nav/ClientDashboardNavComponent.vue": 1184,
	"./components/dashboard/client/partials/nav/ClientMessagesNavComponent.vue": 1006,
	"./components/dashboard/client/partials/nav/ClientPortfolioDetailsNavComponent.vue": 3666,
	"./components/dashboard/client/partials/nav/ClientSettingsNavComponent.vue": 1923,
	"./components/dashboard/client/partials/nav/ClientTradeNavComponent.vue": 8798,
	"./components/dashboard/client/portfolio/IclfFundingComponent.vue": 3125,
	"./components/dashboard/client/portfolio/PortfolioApprovalsComponent.vue": 7788,
	"./components/dashboard/client/portfolio/PortfolioDetailsComponent.vue": 3466,
	"./components/dashboard/client/portfolio/PortfolioFeesComponent.vue": 2041,
	"./components/dashboard/client/profile/BankAccountInformationComponent.vue": 7904,
	"./components/dashboard/client/profile/ExecutiveInformationComponent.vue": 6006,
	"./components/dashboard/client/profile/FinancialInformationComponent.vue": 4483,
	"./components/dashboard/client/profile/InvestmentManagementAgreementComponent.vue": 5776,
	"./components/dashboard/client/profile/PersonalInformationComponent.vue": 8780,
	"./components/dashboard/client/profile/ProfileInformationComponent.vue": 2738,
	"./components/dashboard/client/profile/RiskProfileComponent.vue": 4305,
	"./components/dashboard/client/requests/DepositComponent.vue": 1732,
	"./components/dashboard/client/requests/TradeFixedIncomeComponent.vue": 9574,
	"./components/dashboard/client/requests/WithdrawComponent.vue": 8032,
	"./components/dashboard/client/requests/partials/BankDetailsComponent.vue": 3470,
	"./components/dashboard/client/requests/partials/CountdownButton.vue": 9086,
	"./components/dashboard/client/requests/partials/DepositFormComponent.vue": 5699,
	"./components/dashboard/client/requests/partials/RequestSummaryComponent.vue": 7956,
	"./components/dashboard/client/settings/AlertsComponent.vue": 6391,
	"./components/dashboard/client/settings/ChangePasswordComponent.vue": 3235,
	"./components/dashboard/client/settings/SelectCompanyComponent.vue": 6421,
	"./components/dashboard/client/trade/TradeFixedIncomeComponent.vue": 7527,
	"./components/dashboard/client/trade/TradeHistoryComponent.vue": 2275,
	"./components/dashboard/client/trade/TradeLocalStocksComponent.vue": 6926,
	"./components/dashboard/client/trade/partials/CancelTradeModal.vue": 5810,
	"./components/dashboard/client/trade/partials/FixedIncomeTradeCounterComponent.vue": 3882,
	"./components/dashboard/client/trade/partials/FixedIncomeTradeDataCompoonent.vue": 6781,
	"./components/dashboard/client/trade/partials/MarketDataComponent.vue": 8708,
	"./components/dashboard/client/trade/partials/TradeCashBalanceComponent.vue": 4859,
	"./components/dashboard/client/trade/partials/TradeCounterComponent.vue": 1674,
	"./components/dashboard/client/trade/partials/TradeHistoryDataComponent.vue": 8083,
	"./components/dashboard/client/trade/partials/TradeSummaryComponent.vue": 5487,
	"./components/dashboard/partials/BankAccountCardComponent.vue": 6999,
	"./components/dashboard/partials/BankBranchSelectorComponent.vue": 7957,
	"./components/dashboard/partials/BankSelectorComponent.vue": 4690,
	"./components/dashboard/partials/ChangeCurrencyComponent.vue": 7356,
	"./components/dashboard/partials/CityPickerComponent.vue": 7745,
	"./components/dashboard/partials/CommentsComponent.vue": 9972,
	"./components/dashboard/partials/CountryPickerComponent.vue": 1585,
	"./components/dashboard/partials/IclfAnnouncementComponent.vue": 1790,
	"./components/dashboard/partials/PhoneNumberComponent.vue": 5434,
	"./components/dashboard/partials/PortfolioCardComponent.vue": 1522,
	"./components/dashboard/partials/UpdateBoardOfDirectorsComponent.vue": 1759,
	"./components/dashboard/partials/charts/YearPerformanceComponent.vue": 2887,
	"./components/landing/ContactUsComponent.vue": 4599,
	"./components/partials/AccountDetails.vue": 8615,
	"./components/partials/layout/SidebarComponent.vue": 6527,
	"./components/partials/ui/BreadcrumbsComponent.vue": 3536,
	"./components/partials/ui/ButtonComponent.vue": 6711,
	"./components/partials/ui/LoaderComponent.vue": 4523,
	"./components/partials/ui/ProcessComponent.vue": 4532,
	"./components/partials/ui/SpinnerComponent.vue": 8064,
	"./components/security/Csrf.vue": 5157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6273;